import type { Template } from "@/types";

export const LA_05_H5_V0: Template[] = [
{
    id: "la-05-h5v0-01",
    name: "LA 01 - H5V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h5_v0_01.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 92, y: 85, width: 223, height: 151, rotation: 0, imageRotation: 0 },
            { id: "2", x: 92, y: 243, width: 223, height: 150, rotation: 0, imageRotation: 0 },
            { id: "3", x: 323, y: 85, width: 222, height: 151, rotation: 0, imageRotation: 0 },
            { id: "4", x: 323, y: 243, width: 222, height: 150, rotation: 0, imageRotation: 0 },
            { id: "5", x: 729, y: 85, width: 452, height: 307, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h5v0-02",
    name: "LA 02 - H5V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h5_v0_02.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 89, y: 38, width: 459, height: 285, rotation: 0, imageRotation: 0 },
            { id: "2", x: 89, y: 329, width: 148, height: 109, rotation: 0, imageRotation: 0 },
            { id: "3", x: 244, y: 329, width: 148, height: 109, rotation: 0, imageRotation: 0 },
            { id: "4", x: 400, y: 329, width: 148, height: 109, rotation: 0, imageRotation: 0 },
            { id: "5", x: 693, y: 65, width: 525, height: 348, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h5v0-03",
    name: "LA 03 - H5V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h5_v0_03.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 211, y: 48, width: 216, height: 123, rotation: 0, imageRotation: 0 },
            { id: "2", x: 211, y: 177, width: 216, height: 122, rotation: 0, imageRotation: 0 },
            { id: "3", x: 211, y: 307, width: 216, height: 122, rotation: 0, imageRotation: 0 },
            { id: "4", x: 805, y: 48, width: 302, height: 187, rotation: 0, imageRotation: 0 },
            { id: "5", x: 805, y: 242, width: 302, height: 186, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h5v0-04",
    name: "LA 04 - H5V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h5_v0_04.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 123, y: 174, width: 192, height: 126, rotation: 0, imageRotation: 0 },
            { id: "2", x: 223, y: 40, width: 192, height: 126, rotation: 0, imageRotation: 0 },
            { id: "3", x: 223, y: 308, width: 192, height: 126, rotation: 0, imageRotation: 0 },
            { id: "4", x: 323, y: 174, width: 191, height: 126, rotation: 0, imageRotation: 0 },
            { id: "5", x: 706, y: 72, width: 501, height: 333, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h5v0-05",
    name: "LA 05 - H5V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h5_v0_05.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 150, width: 249, height: 177, rotation: 0, imageRotation: 0 },
            { id: "2", x: 256, y: 150, width: 249, height: 177, rotation: 0, imageRotation: 0 },
            { id: "3", x: 513, y: 150, width: 249, height: 177, rotation: 0, imageRotation: 0 },
            { id: "4", x: 769, y: 150, width: 249, height: 177, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1025, y: 150, width: 249, height: 177, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h5v0-06",
    name: "LA 06 - H5V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h5_v0_06.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 38, y: 155, width: 234, height: 167, rotation: 0, imageRotation: 0 },
            { id: "2", x: 279, y: 155, width: 234, height: 167, rotation: 0, imageRotation: 0 },
            { id: "3", x: 520, y: 155, width: 234, height: 167, rotation: 0, imageRotation: 0 },
            { id: "4", x: 761, y: 155, width: 234, height: 167, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1003, y: 155, width: 234, height: 167, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h5v0-07",
    name: "LA 07 - H5V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h5_v0_07.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 411, y: 32, width: 610, height: 411, rotation: 0, imageRotation: 0 },
            { id: "2", x: 254, y: 346, width: 149, height: 98, rotation: 0, imageRotation: 0 },
            { id: "3", x: 254, y: 241, width: 149, height: 98, rotation: 0, imageRotation: 0 },
            { id: "4", x: 254, y: 137, width: 149, height: 98, rotation: 0, imageRotation: 0 },
            { id: "5", x: 254, y: 32, width: 149, height: 98, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h5v0-08",
    name: "LA 08 - H5V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h5_v0_08.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 39, y: 49, width: 559, height: 376, rotation: 0, imageRotation: 0 },
            { id: "2", x: 676, y: 49, width: 276, height: 185, rotation: 0, imageRotation: 0 },
            { id: "3", x: 676, y: 241, width: 276, height: 184, rotation: 0, imageRotation: 0 },
            { id: "4", x: 959, y: 49, width: 275, height: 185, rotation: 0, imageRotation: 0 },
            { id: "5", x: 959, y: 241, width: 275, height: 184, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h5v0-09",
    name: "LA 09 - H5V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h5_v0_09.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 46, y: 40, width: 290, height: 195, rotation: 0, imageRotation: 0 },
            { id: "2", x: 46, y: 242, width: 290, height: 194, rotation: 0, imageRotation: 0 },
            { id: "3", x: 344, y: 40, width: 586, height: 395, rotation: 0, imageRotation: 0 },
            { id: "4", x: 938, y: 40, width: 289, height: 195, rotation: 0, imageRotation: 0 },
            { id: "5", x: 938, y: 242, width: 289, height: 194, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h5v0-10",
    name: "LA 10 - H5V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h5_v0_10.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 47, y: 40, width: 290, height: 195, rotation: 0, imageRotation: 0 },
            { id: "2", x: 47, y: 242, width: 290, height: 194, rotation: 0, imageRotation: 0 },
            { id: "3", x: 345, y: 40, width: 289, height: 195, rotation: 0, imageRotation: 0 },
            { id: "4", x: 345, y: 242, width: 289, height: 194, rotation: 0, imageRotation: 0 },
            { id: "5", x: 642, y: 40, width: 586, height: 395, rotation: 0, imageRotation: 0 }
    ],
}
];